import React, { useEffect, useState } from 'react';
import { X, ShoppingCart, Loader2 } from 'lucide-react';
import { BACKEND_URL, fmt } from './promoCart';
import { QuestionLink } from './PromoOfferCard';
import { trackPurchaseOnce } from '../../lib/metaPixel';
import { PromoCheckout } from './PromoCheckout';

export const PromoCartDrawer = ({ open, onClose, cart, offers }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex justify-end" data-testid="promo-cart-drawer">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <aside className="relative w-full max-w-md h-full bg-zinc-950 border-l border-zinc-800 flex flex-col">
        <header className="px-5 py-4 border-b border-zinc-800 flex items-center justify-between">
          <h3 className="text-lg font-bold text-white flex items-center gap-2"><ShoppingCart className="w-5 h-5 text-amber-400" /> Panier promotions</h3>
          <button onClick={onClose} className="text-zinc-400 hover:text-white" data-testid="promo-cart-close"><X className="w-5 h-5" /></button>
        </header>
        <div className="flex-1 overflow-y-auto p-5">
          <PromoCheckout cart={cart} offers={offers} footerClass="sticky bottom-0 -mx-5 -mb-5 mt-5 p-5 bg-zinc-950 border-t border-zinc-800" />
        </div>
      </aside>
    </div>
  );
};

export const PromoPaymentReturn = ({ sessionId, onDone, onPaid }) => {
  const [state, setState] = useState({ status: 'checking' });
  useEffect(() => {
    let tries = 0; let stop = false;
    const poll = async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/promo-offers/checkout/status/${sessionId}`);
        const d = await r.json();
        if (d.payment_status === 'paid') { setState({ status: 'paid', ...d }); trackPurchaseOnce(d.meta_purchase); onPaid(); return; }
        if (!r.ok) { setState({ status: 'error' }); return; }
      } catch { /* retry */ }
      if (!stop && ++tries < 15) setTimeout(poll, 2000); else if (!stop) setState({ status: 'pending' });
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto my-16 bg-zinc-900 border border-zinc-800 rounded-2xl p-10 text-center" data-testid="promo-payment-return">
      {state.status === 'checking' && <><Loader2 className="w-10 h-10 text-amber-400 animate-spin mx-auto mb-4" /><p className="text-white">Vérification du paiement…</p></>}
      {state.status === 'paid' && (
        <div data-testid="promo-payment-success">
          <h2 className="text-2xl font-bold text-white mb-2">Merci, paiement confirmé !</h2>
          <p className="text-zinc-400">Commande <span className="text-amber-400 font-mono" data-testid="promo-payment-order-number">{state.order_number}</span></p>
          <p className="text-zinc-400 mb-4">Montant payé : CHF {fmt(state.total_ttc)} TTC. Confirmation et facture envoyées par e-mail.</p>
          <div className="mb-6 flex justify-center"><QuestionLink subject={`Question sur la commande ${state.order_number}`} testid="promo-payment-question" /></div>
        </div>
      )}
      {state.status === 'pending' && <p className="text-zinc-300 mb-6" data-testid="promo-payment-pending">Paiement en cours de confirmation. Vous recevrez un e-mail dès validation.</p>}
      {state.status === 'error' && <p className="text-red-400 mb-6" data-testid="promo-payment-error">Paiement introuvable. Contactez-nous : info@ledzone.ch</p>}
      {state.status !== 'checking' && <button onClick={onDone} className="bg-amber-500 text-black px-8 py-3 rounded-lg font-bold hover:bg-amber-400" data-testid="promo-payment-continue">Retour aux promotions</button>}
    </div>
  );
};
